export function formatLimpiar(texto) {
  const textoLimpio = texto.replace(/[^\w\s]/gi, ' ');
  const textoSinEspaciosMultiples = textoLimpio.replace(/\s+/g, ' ').trim();
  const textoFormateado = textoSinEspaciosMultiples
    .toLowerCase()
    .replace(/(?:^|\s)\S/g, (letra) => letra.toUpperCase());
  return textoFormateado.replace(/Cerrar Evento/g, 'Cerrar Protocolo');
}
